/* eslint-disable react/prop-types */
import React from 'react';
import { Download, Language, ViewInAr } from '@mui/icons-material';
import gitmeLogo from '../../images/logo/gitme-logo.svg';

const ShareActions = ({
  badge,
  onCopyVerificationLink,
  onEmbedBadge,
  onDownloadPreview
}) => {
  const isLocked = badge?.status === 'not_earned';

  return (
    <div className="space-y-4 border-t border-slate-100 pt-5">
      <div className="flex items-center justify-center gap-2.5 text-slate-700">
        <img src={gitmeLogo} alt="GitMe logo" className="h-5 w-auto" />
        <span className="text-sm font-semibold">Certified</span>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          type="button"
          onClick={onDownloadPreview}
          disabled={isLocked}
          aria-label={`Download LinkedIn preview for ${badge?.display_name || 'certification'}`}
          className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-2xl border-2 border-indigo-600 bg-indigo-600 px-4 py-2.5 text-sm font-bold text-white shadow-md transition-all duration-200 hover:bg-indigo-700 hover:shadow-lg disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400 disabled:shadow-none"
        >
          <Download sx={{ fontSize: 17 }} />
          Download preview
        </button>
        <button
          type="button"
          onClick={onCopyVerificationLink}
          disabled={isLocked || !badge?.share_url}
          aria-label={`Copy share link for ${badge?.display_name || 'certification'}`}
          className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-2xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition-all duration-200 hover:border-slate-400 hover:bg-slate-50 hover:shadow-md disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400 disabled:shadow-none"
        >
          <Language sx={{ fontSize: 17 }} />
          Copy share link
        </button>
      </div>

      <button
        type="button"
        onClick={onEmbedBadge}
        disabled={isLocked || !badge?.embed_url}
        aria-label={`Embed ${badge?.display_name || 'certification'} to your website`}
        className="inline-flex items-center justify-center gap-2.5 text-sm font-semibold text-slate-600 transition hover:text-slate-900 disabled:cursor-not-allowed disabled:text-slate-300"
      >
        <ViewInAr sx={{ fontSize: 18 }} />
        Embed to your website
      </button>
    </div>
  );
};

export default ShareActions;
